"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLightTheme;
var _deepMerge = _interopRequireDefault(require("../../utils/deep-merge"));
var _utils = require("../utils");
var _tokens = require("../../tokens");
var _colorComponentTokens = _interopRequireDefault(require("./color-component-tokens"));
var _colorSemanticTokens = _interopRequireDefault(require("./color-semantic-tokens"));
var _colorFoundationTokens = _interopRequireDefault(require("./color-foundation-tokens"));
var _lightTheme = require("./light-theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function createLightTheme(overrides) {
  const foundationColors = {
    ..._colorFoundationTokens.default,
    ...(0, _utils.getFoundationColorOverrides)(overrides?.colors)
  };
  const semanticColors = (0, _colorSemanticTokens.default)(foundationColors);
  const componentColors = (0, _colorComponentTokens.default)(semanticColors);
  const theme = {
    ...structuredClone(_lightTheme.LightTheme),
    colors: {
      ..._tokens.primitiveColors,
      ...foundationColors,
      ...semanticColors,
      ...componentColors
    }
  };
  return (0, _deepMerge.default)(theme, overrides);
}